import { isServer } from '@tanstack/react-query'
import { getQueryClient } from '@/lib/queryClient'
import { useAuthStore } from '@/stores/useAuthStore'
import { useCartStore } from '@/stores/useCartStore'
import { useCheckoutStore } from '@/stores/useCheckoutStore'
import { useCouponStore } from '@/stores/useCouponStore'
import { useProductStore } from '@/stores/useProductStore'
import { useZipCodeStore } from '@/stores/useZipCodeStore'
import { removeLegacyStorage } from './legacyStorage'

/**
 * Apaga os dados do cliente: volta as stores dele ao estado inicial (e, nas persistidas, o que está no localStorage) e
 * limpa o cache do React Query do navegador. Chamado no logout e na sessão expirada, para nada de um cliente ficar para o próximo no
 * mesmo navegador. Toda store nova com dado do cliente registra o `resetStore` aqui.
 *
 * Fica de fora o que não é do cliente: a `useLoaderStore` (zerar o contador com requisição no ar faria o `stopLoading`
 * dela descontar a próxima).
 */
export function clearAllStores(): void {
    useAuthStore.getState().resetStore()
    useCartStore.getState().resetStore()
    useCheckoutStore.getState().resetStore()
    useCouponStore.getState().resetStore()
    useProductStore.getState().resetStore()
    useZipCodeStore.getState().resetStore()
    removeLegacyStorage()
    if (!isServer) getQueryClient().clear()
}
